/* eslint-disable no-console */
/* eslint-disable max-len */
import SearchIcon from '@mui/icons-material/Search';
import { Box, Grid, IconButton, InputBase, Stack, styled, Typography, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { CiFilter } from 'react-icons/ci';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import NewsfeedIocn from '../../../../assets/SideNavIcons/News_Feed.svg';
import FilterSlider from '../../../../components/Common/FilterSlider';
import { LanguageContext } from '../../../../libs/Context';
import EventsFilter from '../LeftPart/CelebrationsEvents/Components/EventFilter';
import useGetComponentName from '../../../../libs/CustomHooks/useGetCompInfo';
import { useSelector } from 'react-redux';
import useGetRelIndData from '../CustomHooks/useGetRelIndD';

const StyledInputBase = styled(InputBase)(({ theme, disabled, value }) => ({
	'& .MuiInputBase-input' : {
		paddingRight : theme.spacing(1),
		transition   : theme.transitions.create('width'),
		width        : value === '' && '0px',
		'&:focus'    : {
			width  : 'var(--font200)',
			cursor : 'text'
		},
		cursor : disabled ? 'default' : 'text'
	},
	'& .MuiInputAdornment-root, & .MuiIconButton-root' : {
		cursor        : disabled ? 'default' : 'pointer',
		opacity       : disabled ? 0.5 : 1,
		pointerEvents : disabled ? 'none' : 'auto',
		padding       : 'var(--pixel4)'
	}
}));

const FeedTitleHeader = (props) =>
{
	const { setInputValue, selectedFilter, setFeedCardActn, inputValue, setSelectedFilter } = props;
	const componentName = useGetComponentName(1);
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const navigate = useNavigate();
	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
	const handleNewsFeed = () => { navigate('/news'); setFeedCardActn([]); };
	const inputRef = useRef<HTMLInputElement>(null);
	const [ searchParams ] = useSearchParams();
	const paramsValue = searchParams.get('post');
	const { type }:any = useParams() ?? '';
	const isMobileSM = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
	const [ openFilter, setOpenFilter ] = useState<any>(false);
	const totalLength:number = useMemo(() => Object.values(selectedFilter).reduce((sum:number, value:any) => sum + value.length, 0), [ selectedFilter ]) || 0;
	const getFiltrData = useGetRelIndData();
	const [ relationsList, setRelationsList ] = useState(null);
	const [ industryList, setIndustryList ] = useState(null);

	const handleSearchClick = () =>
	{
		if (inputRef.current) inputRef.current.focus();
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
	{
		setInputValue(e.target.value.trimStart());
	};

	const handleApplyFilter = useCallback((data:any) =>
	{
		setSelectedFilter({ ...data });
		setOpenFilter(false);
	}, []);

	const paramsType:any = {
		celebrationevents : 'Event Cards',
		myactivity        : 'My Activity',
		popularfeeds      : 'Popular Feeds',
		pendingapproval   : 'Feeds pending for Approval'
	};

	const newsFeedFilterFun = async () =>
	{
		const fetchedRelations = userData?.role !== 'individual' && await getFiltrData(() => {}, 'relations');
		const fetchedIndustry = await getFiltrData(() => {}, 'industryTypes');

		setRelationsList(fetchedRelations);
		setIndustryList(fetchedIndustry);
	};

	useEffect(() =>
	{
		if (userData?.role === 'employee')
		{
			newsFeedFilterFun();
		}
	}, []);

	return (
		<>
			<Grid container item position='sticky' top={isMobile ? 'var(--pixel56)' : 'var(--pixel64)'} zIndex={99} padding={1} justifyContent='space-between' alignItems='center' sx={{ backgroundColor: 'var(--whiteColor)' }} height={isMobileSM ? 'auto' : 'var(--pixel64)'}>
				<Grid item xs>
					<Stack direction='row' alignItems='center'>
						<Box display='flex' px='var(--pixel8)' alignItems='center' tabIndex={0}>
							<Box
								component='img'
								src={NewsfeedIocn}
								sx={{ marginRight: 1, filter: type && 'invert(49%) sepia(98%) saturate(365%) hue-rotate(145deg) brightness(93%) contrast(92%)' }}
								alt='Meeting Room Icon'
								height='var(--pixel18)'
								width='var(--pixel18)'
							/>
							<Typography variant='h6' fontWeight='var(--font500)' color={type && 'var(--primaryColor)'} sx={{ cursor: (type || paramsValue) && 'pointer' }} onClick={handleNewsFeed}>
								{componentName}
							</Typography>
							{(paramsValue || type) && (
								<Typography variant='body2' textTransform='capitalize' pt={'4px'} display='flex' alignItems='center' fontWeight='var(--font500)' color='textPrimary' pl='var(--pixel4)'>
									<MdKeyboardArrowRight fontSize='var(--pixel20)' />
									{` ${paramsType?.[type] || type || ''}`}
									{paramsValue && <span id='individual_post_name'/>}
								</Typography>
							)}
						</Box>
					</Stack>
				</Grid>
				<Grid item pr='var(--pixel8)' display='flex' flexDirection='row' alignItems='center' id='FeedTitleHeader'>
					{type !== 'celebrationevents' &&
					<StyledInputBase
						className={'whiteBg'}
						inputRef={inputRef}
						type='search'
						placeholder={language?.search}
						value={inputValue}
						onChange={handleChange}
						startAdornment={
							<IconButton onClick={handleSearchClick} disabled={false}>
								<SearchIcon color='action' />
							</IconButton>
						}
					/>}
					{userData?.role !== 'individual' && type !== 'draft' &&
					<Box
						onClick={() => setOpenFilter(!openFilter)}
						sx={{
							width        : '36px',
							borderRadius : 'var(--pixel8)',
							height       : '36px',
							border       : '1px solid #DCDEE4',
							cursor       : 'pointer'
						}}
						display='flex'
						justifyContent='center'
						alignItems='center'
						ml={1}
					>
						<CiFilter fontSize='var(--pixel22)' />
						{Object?.keys(selectedFilter)?.length > 0 && (
							<Box
								sx={{
									width           : 'var(--pixel16)',
									height          : 'var(--pixel16)',
									backgroundColor : '#EA4D4D',
									position        : 'absolute',
									top             : 4,
									right           : 8,
									display         : 'flex',
									justifyContent  : 'center',
									alignItems      : 'center',
									borderRadius    : 'var(--percent50)',
									color           : 'white',
									fontSize        : 'var(--pixel10)'
								}}
							>
								{totalLength || 0 }
							</Box>
						)}
					</Box>}
				</Grid>
			</Grid>
			{openFilter && (
				type !== 'celebrationevents'
					? (
						<FilterSlider
							isDrawerOpen={openFilter}
							newsFeedFilterFuction={newsFeedFilterFun}
							relationsList={relationsList}
							industryList={industryList}
							handleApplyFilter={handleApplyFilter}
							selectedFilterOptions={selectedFilter}
							filterType='newsfeeds'
							handleClose={() => setOpenFilter((prev) => !prev)}
						/>
					)
					: (
						<EventsFilter
							isDrawerOpen={openFilter}
							handleClose={() => setOpenFilter((prev) => !prev)}
						/>
					)
			)}

		</>
	);
};

export default FeedTitleHeader;